import { render, staticRenderFns } from "./debatePage.vue?vue&type=template&id=6de29836&"
import script from "./debatePage.vue?vue&type=script&lang=js&"
export * from "./debatePage.vue?vue&type=script&lang=js&"
import style0 from "./debatePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports